import React from 'react';

import {Row, ProductCategoryItem, ProductCategoryImage} from './styles';
import {RFValue} from 'react-native-responsive-fontsize';
import {useTheme} from 'styled-components/native';

export function CategoryShimmer() {
  const theme = useTheme();
  return (
    <>
      <Row>
        <ProductCategoryItem
          style={{
            width: '100%',
          }}>
          <ProductCategoryImage
            shimmerColors={theme.colors.shimmer_placeholder}
          />
        </ProductCategoryItem>
      </Row>
      <Row>
        <ProductCategoryItem
          style={{
            width: '100%',
          }}>
          <ProductCategoryImage
            shimmerColors={theme.colors.shimmer_placeholder}
          />
        </ProductCategoryItem>
      </Row>
      <Row>
        <ProductCategoryItem
          style={{
            width: '100%',
          }}>
          <ProductCategoryImage
            shimmerColors={theme.colors.shimmer_placeholder}
          />
        </ProductCategoryItem>
      </Row>

      <Row>
        <ProductCategoryItem
          style={{
            paddingRight: RFValue(6),
          }}>
          <ProductCategoryImage
            shimmerColors={theme.colors.shimmer_placeholder}
          />
        </ProductCategoryItem>

        <ProductCategoryItem
          style={{
            paddingLeft: RFValue(6),
          }}>
          <ProductCategoryImage
            shimmerColors={theme.colors.shimmer_placeholder}
          />
        </ProductCategoryItem>
      </Row>
      <Row>
        <ProductCategoryItem
          style={{
            paddingRight: RFValue(6),
          }}>
          <ProductCategoryImage
            shimmerColors={theme.colors.shimmer_placeholder}
          />
        </ProductCategoryItem>
        <ProductCategoryItem
          style={{
            paddingLeft: RFValue(6),
          }}>
          <ProductCategoryImage
            shimmerColors={theme.colors.shimmer_placeholder}
          />
        </ProductCategoryItem>
      </Row>



    </>
  );
}
